<template>
    <div>
        <div id="slider-scroll">
            <div class="section section_three firstSlider" v-if="$i18n.locale=='en'">
                
                <div class="main_slider">
                    <div class="container-fluid">
                        <div class="activity__counter">
                            <span> {{ currentSlide }} </span> / {{ totalSlides }}
                        </div>
                    </div>
                    <div class="container-fluid slider-wrapper">
                        <hooper @slide="updateCarousel" :settings="hooperSettings" ref="carousel" >        
                            <slide >
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/baharain-img.png" alt="baharain">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/bahrain.png" alt="baharain flag">
                                            </div>
                                           BAHRAIN
                                        </div>
                                        <div class="scrollWrapper">
                                            <scrollbar :ops="scrollSettings">
                                                <ul class="round-circle">
                                                    <li>
                                                        To support other businesses during the work-from home period, the company offered them free 
                                                        broadband routers and MiFi packages for a period of 
                                                        3-6 months.
                                                    </li>
                                                    <li>
                                                        In Bahrain, Zain provided an educational package to 
                                                        students for free access to all educational platforms
                                                        used to complete schoolwork online. This offer 
                                                        extended to zero-rated educational platforms that 
                                                        were offered to all home broadband customers: 
                                                        <ul class="list-unstyled">
                                                            <li><span>-</span> Microsoft Teams</li>
                                                            <li><span>-</span> Google Hangouts</li>
                                                            <li><span>-</span> Class Dojo</li>
                                                            <li><span>-</span> University of Bahrain portal</li>
                                                            <li><span>-</span> ASU portal</li>
                                                            <li><span>-</span> BIBF portal </li>
                                                            <li><span>-</span> Polytechnic portal </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </scrollbar>
                                        </div>
                                    </div>
                                </div>
                            </slide>    
                            <slide>
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/Iraq-img.png" alt="iraq">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/iraq.png" alt="iraq flag">
                                            </div>
                                            IRAQ
                                        </div>
                                        
                                        <ul class="round-circle">
                                            <li>
                                                Zain Iraq donated 750 million Iraqi dinars
                                                (USD 630,000) in support of the health care sector. 
                                            </li>
                                            <li>
                                                An employee-led awareness video to encourage 
                                                citizens to stay at home and follow health instructions 
                                                was developed. Zain Iraq produced another video 
                                                that is disability inclusive, with the videos reaching 
                                                over 5.7 million people via Facebook.
                                                
                                            </li>
                                        </ul>
                                        
                                    </div>
                                </div>
                            </slide> 
                            <slide >
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/jordan.png" alt="jordan">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/jordan.png" alt="jordan flag">
                                            </div>
                                            JORDAN
                                        </div>
                                        <div class="scrollWrapper">
                                        <scrollbar :ops="scrollSettings">
                                            <ul class="round-circle">
                                                <li>
                                                    Zain Jordan provided free internet browsing over its 
                                                    network for the Ministry of Education’s electronic 
                                                    learning platform (Darsak). Students, parents, and 
                                                    caregivers were able to browse the Ministry’s 
                                                    e-learning platform for free and without deduction 
                                                    from their balances or internet packages on their 
                                                    cellular lines or home internet subscriptions.
                                                </li>
                                                <li>
                                                    To support the efforts of the Ministry of Social 
                                                        Development, Zain and its employees donated 
                                                        20,000 JDs (USD 28,209) to the Alkhair Fund.
                                                        The fund supported 245 underprivileged families 
                                                        and unemployed people who lost their income due 
                                                        to the crisis. 
                                                    
                                                </li>
                                                <li>
                                                    Zain Jordan’s Innovation Campus (ZINC) supported
                                                    the Startup Week Jordan - COVID 19 online event, organized by ZAD Online Consulting Company in 
                                                    cooperation with the European Union delegation in 
                                                    Jordan and the Leaders International Foundation.
                                                    The aim of the event was to find innovative ideas and 
                                                    provide workable solutions to help manage the crisis 
                                                    caused by the pandemic. 80 tech startups in Jordan 
                                                    participated in the event. 
                                                </li>
                                            </ul>
                                        </scrollbar>
                                        </div>
                                    </div>
                                </div>
                            </slide> 
                            <slide>
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/kuwait.png" alt="kuwait">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/kuwait.png" alt="kuwait flag">
                                            </div>
                                            KUWAIT
                                        </div>
                                        <div class="scrollWrapper">
                                        <scrollbar :ops="scrollSettings">
                                                <ul class="round-circle">
                                                    <li> Effective April 18, Zain Kuwait in collaboration with 
                                                        the Ministry of Health (MoH) and the Central Agency 
                                                        for Information Technology (CAIT) launched the 
                                                        Shlonik app, which utilized the latest tech solutions to 
                                                        monitor the compliance of citizens who recently 
                                                        returned to Kuwait with self-quarantine directives. The 
                                                        app forms part of the Kuwait government’s evacuation 
                                                        plan as related to home quarantine instructions. It was 
                                                        developed internally by Zain and is an essential tool 
                                                        paired with a smart wrist bracelet distributed at 
                                                        Kuwait International Airport to anyone taking part in 
                                                        home quarantine. In support of the comprehensive 
                                                        awareness campaign conducted by the country’s 
                                                        various institutions, Zain Kuwait changed its network’s 
                                                        name to Shlonik, which translates to ‘how are you’ in 
                                                        the Arabic Kuwaiti dialect.
                                                    </li>
                                                    <li>
                                                        Zain Kuwait supported the National Counselling 
                                                        Program for COVID-19 (Corona Care Kw), a volunteer 
                                                        program that offers a free online interactive platform 
                                                        for mental health support to the Kuwaiti community. 
                                                        Zain Kuwait offered free lines to the program’s team to 
                                                        facilitate their communication and coordination, as well 
                                                        as sent free bulk SMS to the public to introduce the 
                                                        program and broadcast its cause. Zain also supported 
                                                        the program by posting its goals on the company’s 
                                                        official social media channels to reach a wider audience 
                                                        and contribute to help contribute to the mental 
                                                        wellbeing of the community as much as possible. 
                                                        Corona Care Kw offers an interactive online platform to 
                                                        serve the mental wellbeing of people in Kuwait during 
                                                        the pandemic. The initiative’s team includes over 900 
                                                        expert volunteers, including over 70 counsellors. The 
                                                        program follows standards that are adopted by the 
                                                        World Health Organization (WHO) with a capacity of 
                                                        over 300 sessions per week to provide the required 
                                                        results and contribute to assisting anyone who may 
                                                        need mental support during the crisis.
                                                    </li>
                                                    
                                                </ul>
                                        </scrollbar>
                                        </div>
                                    </div>
                                </div>
                            </slide>
                            <slide>
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/saudia-arabia.png" alt="saudia-arabia">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/saudia.png" alt="saudia flag">
                                            </div>
                                            SAUDI ARABIA 
                                        </div>
                                        <scrollbar :ops="scrollSettings">
                                        <ul class="round-circle">
                                            <li>
                                                Zain zero-rated all the Ministry of Health and 
                                                Ministry of Information websites, as well as official 
                                                educational platforms to enable customers to access 
                                                important information and services free-of-charge. 
                                                This service was applicable to all Zain customers 
                                                across the Kingdom. Around 6.5 million students 
                                                have subscribed to the service. 
                                            </li>
                                            <li>
                                                Supporting people who are quarantined in hospitals, 
                                                the company provided its customers in quarantine 
                                                with free voice and data for the entire month of April.
                                            </li>
                                        </ul>
                                        </scrollbar>
                                    </div>
                                </div>
                            </slide>
                            <slide >
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/sudan.png" alt="sudan">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/sudan.png" alt="sudan flag">
                                            </div>
                                            SUDAN
                                        </div>
                                        <div class="scrollWrapper">
                                        <scrollbar :ops="scrollSettings">
                                                <ul class="round-circle">
                                                    <li>
                                                        Zain Sudan provided a total of 50,000 liters
                                                        of sanitizer to hospitals across the country and
                                                        public places. 
                                                    </li>
                                                    <li>
                                                        The company renovated one of its buildings to 
                                                        donate to the health sector in its bid to increase 
                                                        capacity for people in quarantine. The building 
                                                        comprises six floors with a capacity for 200 beds. 
                                                        
                                                    </li>
                                                    <li>
                                                        In Sudan, Zain sent out 60 million SMS to spread 
                                                        awareness on prevention tips and communicate 
                                                        advice and messages provided by the Ministry of 
                                                        Health and other governmental entities. In addition, 
                                                        the company launched awareness campaigns via
                                                        its social media channels that are inclusive and 
                                                        accessible to people with disabilities. 
                                                    </li>
                                                </ul>
                                        </scrollbar>
                                        </div>
                                    </div>
                                </div>
                            </slide>
                            <slide >
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/south-sudan.png" alt="south-sudan">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/south-sudan.png" alt="south sudan flag">
                                            </div>
                                            SOUTH SUDAN
                                        </div>
                                        <div class="scrollWrapper">
                                            <scrollbar :ops="scrollSettings">
                                                <ul class="round-circle">
                                                    <li>
                                                        Under Zain South Sudan’s e-health portal, the 
                                                        company developed a management system that 
                                                        provided customers with information from credible 
                                                        sources such as WHO, local government entities, 
                                                        and international medical agencies.
                                                    </li>
                                                    <li>
                                                        Zain South Sudan conducted staff orientation 
                                                        sessions on COVID-19, in addition to publishing 
                                                        advice and banners offering preventative tips at the 
                                                        headquarters, and retail stores.
                                                        
                                                    </li>
                                                    <li>
                                                        The company provided the Ministry of Health and 
                                                        Emergency Operations Center with 200 free voice 
                                                        minutes and 10 GB data per person working in the 
                                                        center to ease in facilitating their day-to-day work.
                                                        In addition, Zain configured a hotline (6666) and 
                                                        donated 50 mobile handsets to support the center. 
                                                        The company also donated basic supplies, including: 
                                                        <ul>
                                                            <li><span>-</span> 600 bottles of Dettol liquid</li>
                                                            <li><span>-</span> 74 laboratory coats</li>
                                                            <li><span>-</span> 7,720 bars of Dettol soap</li>
                                                            <li><span>-</span> 5,500 face masks</li>
                                                            <li><span>-</span> 800 bottles of surgical spirit<br>(disinfectants ethanol-based liquids)</li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        Under Zain Group’s Women Empowerment 
                                                        program, WE 2020 Champions in South Sudan 
                                                        helped distribute meals to displaced people,
                                                        the homeless, orphans and people suffering from 
                                                        HIV/AIDs in Juba during the lockdown periods.
                                                        This initiative was established to empower and 
                                                        support women who used to earn their income
                                                        from small businesses that were closed down 
                                                        during the pandemic. 37 families were supported 
                                                        through this program. 
                                                    </li>
                                                </ul>
                                            </scrollbar>
                                        </div>
                                    </div>
                                </div>
                            </slide>
                            <hooper-navigation slot="hooper-addons"></hooper-navigation>       
                        </hooper>
                        <div class="cursurControl">
                            <div id="left" class="slider-nav" @click.prevent="slidePrev"></div>
                            <div id="right" class="slider-nav" @click.prevent="slideNext"></div>
                        </div>
                    </div>
                    
                    
                </div>    
                
            </div>
            <div class="section section_three firstSlider" v-if="$i18n.locale=='ar'">
                
                <div class="main_slider">
                    <div class="container-fluid">
                        <div class="activity__counter">
                            <span> {{ currentSlide }} </span> / {{ totalSlides }}
                        </div>
                    </div>
                    <div class="container-fluid slider-wrapper">
                        <hooper @slide="updateCarousel" :settings="hooperSettings" ref="carousel" >        
                            <slide >
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/baharain-img.png" alt="baharain">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/bahrain.png" alt="baharain flag">
                                            </div>
                                            البحرين
                                        </div>
                                        <div class="scrollWrapper">
                                            <scrollbar :ops="scrollSettings">
                                                <ul class="round-circle">
                                                    <li>
                                                        بهدف دعم شركات الأعمال التجارية خلال فترات العمل من المنزل، قدمت زين لتلك الشركات أجهزة راوتر نطاق عريض وباقات MiFi  مجانية لمدة 3 إلى 6 أشهر.
                                                    </li>
                                                    <li>
                                                        فـي البحريـن، قدمـت زيـن باقـة تعليميـة للطـلاب لتمكينهـم من الوصول المجاني إلى جميع المنصـات التعليميـة المستخدمـة لاستكمال الدراسة عبر الإنترنت، وامتد هذا العرض ليشمل توفير منصات تعليمية معفاة من الرسوم، التي تم تقديمها لجميع عملاء النطاق العريض المنزلي، وتلك المنصات هي:
                                                        <ul class="list-unstyled">
                                                            <li><span>-</span> Microsoft Teams</li>
                                                            <li><span>-</span> Google Hangouts</li>
                                                            <li><span>-</span> Class Dojo</li>
                                                            <li><span>-</span> بوابة جامعة البحرين (UoB)</li>
                                                            <li><span>-</span> بوابة جامعة (ASU) </li>
                                                            <li><span>-</span> بوابة معهد البحرين للدراسات المصرفية والمالية (BIBF) </li>
                                                            <li><span>-</span>بوابة Polytechnic </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </scrollbar>
                                        </div>
                                    </div>
                                </div>
                            </slide>    
                            <slide>
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/Iraq-img.png" alt="iraq">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/iraq.png" alt="iraq flag">
                                            </div>
                                            العراق
                                        </div>
                                        
                                        <ul class="round-circle">
                                            <li>
                                                 تبرعـت شركـة زيـن العـراق بمبلـغ 750 مليـون دينـار عراقـي 
                                                (630,000 دولار أمريكي) لدعم قطاع الرعاية الصحية. 
                                            </li>
                                            <li>
                                                تم إنتاج فيديو توعوي بقيادة موظفي الشركة لتشجيع المواطنين على البقاء في المنزل واتباع التعليمات الصحية، كما أنتجت شركة زين العراق مقطع فيديو آخر يشمل أصحاب الاحتياجات الخاصة، حيث وصلت مشاهدات مقطعي الفيديو إلى أكثر من 5.7 مليون شخص عبر فيسبوك.
                                                
                                            </li>
                                        </ul>
                                        
                                    </div>
                                </div>
                            </slide> 
                            <slide >
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/jordan.png" alt="jordan">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/jordan.png" alt="jordan flag">
                                            </div>
                                            الأردن
                                        </div>
                                        <div class="scrollWrapper">
                                        <scrollbar :ops="scrollSettings">
                                            <ul class="round-circle">
                                                <li>
                                                    أتاحت شركة زين الأردن تصفحاً مجانياً للإنترنت عبر شبكتها لمنصة التعلُّم الإلكترونية (درسك) التابعة لوزارة التربية والتعليم، حيث تمكَّن الطلاب وأولياء الأمور ومقدمو الرعاية من تصفح منصة التعلُّم الإلكترونية التابعة للوزارة مجاناً وبدون خصم من أرصدتهم أو من باقات الإنترنت على خطوطهم أو اشتراكات الإنترنت المنزلية.
                                                </li>
                                                <li>
                                                   في إطار دعم جهود وزارة التنمية الاجتماعية، تبرعت شركة زين وموظفوها بمبلغ 20,000 دينار أردني (28,209 دولار أمريكي) لـ”صنـدوق الخيـر“، وبـدوره دعـم الصنـدوق 245 من أفـراد الأسـر الفقيرة والعاطلين عن العمل الذين فقدوا دخلهم بسبب الأزمة.
                                                    
                                                </li>
                                                <li>
                                                    قدمت منصة زين للإبداع (ZINC) التابعة لشركة زين الأردن الدعم إلى فعالية ”ستارتب ويكند الأردن - كوفيد-19“ عبر الإنترنت،  وهي الفعالية التي نظمتها شركة ”زاد“ للاستشارات بالتعاون مع وفد الاتحاد الأوروبي في الأردن ومؤسسة ليدرز الدولية، وكان الهدف من وراء ذلك الحدث هو إيجاد أفكار مبتكرة وتقديم حلول عملية للمساعدة في إدارة الأزمة الناجمة عن الجائحة، وقد شاركت 80 شركة تقنية ناشئة في الأردن في هذا الحدث.
                                                </li>
                                            </ul>
                                        </scrollbar>
                                        </div>
                                    </div>
                                </div>
                            </slide> 
                            <slide>
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/kuwait.png" alt="kuwait">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/kuwait.png" alt="kuwait flag">
                                            </div>
                                            الكويت
                                        </div>
                                        <div class="scrollWrapper">
                                        <scrollbar :ops="scrollSettings">
                                                <ul class="round-circle">
                                                    <li> اعتباراً من 18 أبريل، أطلقت شركة زين الكويت بالتعاون مع وزارة الصحة والجهاز المركزي لتكنولوجيا المعلومات تطبيق“شلونك ” (Shlonik) الذي استخدم أحدث الحلول التقنية لمراقبة امتثال المواطنين العائدين إلى الكويت لتوجيهات الحجر الصحي، ويشكل ذلك التطبيق جزءاً من خطة الإخلاء التي وضعتها حكومة الكويت في ما يتعلق بتعليمات الحجر الصحي المنزلي.
                                                    </li>
                                                    <li>
                                                           تم تطوير التطبيق داخلياً من جانب شركة زين، وهو أداة أساسية مقترنة بسوار معصم ذكي يتم توزيعه في مطار الكويت الدولي لأي شخص يتم إدراجه ضمن الحجر الصحي المنزلي، ودعماً لحملة التوعية الشاملة التي أجرتها المؤسسات المختلفة في الدولة، غيَّرت شركة زين الكويت اسم شبكتها إلى ”شلونك“، وهو الاسم الذي يعني ”كيف حالك؟“ باللهجة العربية الكويتية.
                                                    </li>
                                                    <li>
                                                        قدمت شركة زين الكويت الدعم إلى البرنامج الوطني للاستشارات حول كوفيد-19 (Corona Care Kw)، وهو برنامج تطوعي يتيح منصة تفاعلية مجانية عبر الإنترنت لدعم الصحة النفسية للمجتمع الكويتي.
                                                        وأتاحت الشركة خطوطا مجانية لفريق البرنامج لتسهيل التواصل   
                                                        والتنسيق في ما بينهم، بالإضافة إلى إرسال رسائل نصية مجمّعة مجانية إلى الجمهور للتعريف بالبرنامج وبث قضيته، كما دعمت الشركة البرنامج من خلال نشر أهدافه على قنوات التواصل الاجتماعي الرسمية الخاصة بها لتمكين الوصول إلى جمهور أوسع والمساهمة في المساعدة على دعم الرفاهية النفسية للمجتمع 
                                                        قدر المستطاع.
                                                    </li>
                                                    <li>
                                                        قدم برنامج Corona Care Kw منصة تفاعلية عبر الإنترنت لخدمة الصحة النفسية للأشخاص في الكويت أثناء الجائحة، ويضم فريق تلك المبادرة أكثر من 900 خبيرا متطوعا، وأكثر من 70 مستشاراً، ويتَّبع البرنامج المعايير التي اعتمدتها منظمة الصحة العالمية بمعدل أكثر من 300 جلسة في الأسبوع لتقديم النتائج المطلوبة والإسهام في مساعدة أي شخص قد يحتاج إلى دعم نفسي أثناء الأزمة.
                                                    </li>
                                                    
                                                </ul>
                                        </scrollbar>
                                        </div>
                                    </div>
                                </div>
                            </slide>
                            <slide>
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/saudia-arabia.png" alt="saudia-arabia">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/saudia.png" alt="saudia flag">
                                            </div>
                                            السعودية 
                                        </div>
                                        <scrollbar :ops="scrollSettings">
                                        <ul class="round-circle">
                                            <li>
                                                 أعفت شركة زين السعودية جميع مواقع وزارة الصحة ووزارة الإعلام مـن الرسـوم، بالإضافـة إلـى المنصـات التعليميـة الرسميـة، وذلـك لتمكين العملاء من الوصول إلى المعلومات والخدمات المهمة مجاناً، وانطبقت هذه الخدمة على جميع عملاء زين على مستوى المملكة، اشترك في الخدمة حوالي 6.5 مليون طالب.
                                            </li>
                                            <li>
                                                 دعماً للأشخاص المعزولين صحياً في المستشفيات، قامت الشركة بتزويد عملائها في الحجر الصحي بخدمات الصوت والبيانات مجانا طوال شهر أبريل بأكمله.
                                            </li>
                                        </ul>
                                        </scrollbar>
                                    </div>
                                </div>
                            </slide>
                            <slide >
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/sudan.png" alt="sudan">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/sudan.png" alt="sudan flag">
                                            </div>
                                            السودان
                                        </div>
                                        <div class="scrollWrapper">
                                        <scrollbar :ops="scrollSettings">
                                                <ul class="round-circle">
                                                    <li>
                                                         قدمت شركة زين السودان ما مجموعه 50,000 لتر من المطهرات إلى المستشفيات على مستوى الدولة وفي الأماكن العامة. 
                                                    </li>
                                                    <li>
                                                         قامت الشركة بتجهيز والتبرع بأحد مبانيها إلى القطاع الصحي لزيادة الطاقة الاستيعابية للأشخاص المعزولين في الحجر الصحي، يتألف المبنى من ستة طوابق بسعة 200 سرير. 
                                                        
                                                    </li>
                                                    <li>
                                                         في السودان، أرسلت زين 60 مليون رسالة نصية لنشر التوعية حول إرشادات الوقاية وإيصال النصائح والرسائل المقدمة من وزارة الصحة والجهات الحكومية الأخرى، بالإضافة إلى ذلك، أطلقت الشركة حملات توعية عبر قنوات التواصل الاجتماعي الخاصة بها، التي شملت أصحاب الاحتياجات الخاصة. 
                                                    </li>
                                                </ul>
                                        </scrollbar>
                                        </div>
                                    </div>
                                </div>
                            </slide>
                            <slide >
                                <div class="main_card">
                                    <div class="image">
                                        <img src="@/assets/images/corporate-sustainability/south-sudan.png" alt="south-sudan">
                                    </div>
                                    <div class="desc" >
                                        <div class="country">
                                            <div class="flag">
                                                <img src="@/assets/images/big-flags/south-sudan.png" alt="south sudan flag">
                                            </div>
                                            جنوب السودان
                                        </div>
                                        <div class="scrollWrapper">
                                            <scrollbar :ops="scrollSettings">
                                                <ul class="round-circle">
                                                    <li>
                                                        من خلال بوابة الصحة الإلكترونية الخاصة بشركة زين جنوب السودان، طورت الشركة نظام إدارة يزود عملائها بالمعلومات من مصادر موثوقة مثل منظمة الصحة العالمية والهيئات الحكومية المحلية والوكالات الطبية الدولية.
                                                    </li>
                                                    <li>
                                                         نظمت شركة زين جنوب السودان جلسات توجيهية لموظفيها حول جائحة كوفيد-19، إلى جانب نشر نصائح ولافتات في مقرها الرئيسي، وإرشادات وقائية في متاجر البيع بالتجزئة.
                                                        
                                                    </li>
                                                    <li>
                                                        زودت الشركة وزارة الصحة ومركز عمليات الطوارئ بـ200 دقيقة مكالمات مجانية و10 جيجابايت بيانات لكل شخص يعمل في المركز لتسهيل الأعمال اليومية، بالإضافة إلى ذلك، قامت زين بتهيئة وتخصيص خط ساخن (6666)، وتبرعت بـ 50 جهاز هاتف نقال دعماً للمركز، كما تبرعت الشركة بمستلزمات أساسية: 
                                                        <ul>
                                                            <li><span>-</span> 600 زجاجة من المطهرات</li>
                                                            <li><span>-</span> 74 معطف مختبرات</li>
                                                            <li><span>-</span> 7,720  قطعة للتعقيم</li>
                                                            <li><span>-</span> 5,500 كمامة</li>
                                                            <li><span>-</span> 800 عبوات للتطهير الجراحي<br>(مطهرات سائلة أساسها الإيثانول)</li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        في إطار برنامج تمكين المرأة الذي تنفذه مجموعة زين، ساعد متطوعو دورة العام 2020 خلال فترات الإغلاق في جنوب السودان في توزيع وجبات طعام على النازحين والأيتام والأشخاص الذين يعانون من فيروس نقص المناعة البشرية/ الإيدز في جوبا، حيث تم إنشاء هذه المبادرة لتمكين ودعم النساء اللاتي اعتدن على كسب دخلهن من الأعمال التجارية الصغيرة التي تم إغلاقها أثناء الجائحة، وتم تقديم الدعم إلى 37 أسرة من خلال هذا البرنامج. 
                                                    </li>
                                                </ul>
                                            </scrollbar>
                                        </div>
                                    </div>
                                </div>
                            </slide>
                            <hooper-navigation slot="hooper-addons"></hooper-navigation>       
                        </hooper>
                    </div>
                    
                    <div class="cursurControl">
                        <div id="left" class="slider-nav" @click.prevent="slidePrev"></div>
                        <div id="right" class="slider-nav" @click.prevent="slideNext"></div>
                    </div>
                </div>    
                
            </div>
        </div>
    </div>
 

</template>

<script>
import gsap from "gsap";
import Data from "./json/data.json";
import { Hooper, Slide , Navigation as HooperNavigation } from 'hooper';
import "hooper/dist/hooper.css";
const activitysliders = [];
const totalSlides = 7;
export default {
    name:"activitysliders",
    props: {
        scrollSettings: Object,
    },
    components: {
        Hooper,
        Slide,
        HooperNavigation
    },
    data(){
        return{
            activitysliders:Data.activitysliders,
            hooperSettings:{
                centerMode:false,
                rtl: this.$i18n.locale=='en' ? false : true,
                wheelControl: false,
                breakpoints: {
                    0: {
                        centerMode: false,
                        itemsToShow: "1"
                    },
                    1200: {
                        itemsToShow: "1.25"
                    },
                    1600: {
                        centerMode: false,
                        itemsToShow: "1.25"
                    }
                    
                }
            },
            currentSlide: 1,
            totalSlides: 7
        }
    },
    methods: {
        updateCarousel(payload) {
            let cs = payload.currentSlide;
            this.currentSlide = cs + 1;
        },
        controlerHeight(){
            var height = document.querySelector('.firstSlider .main_slider').offsetHeight;
        //    const element =  document.querySelector('.firstSlider .cursurControl .d-flex');
        //    element.style.height = `${(height / 2)+55}px`;
        },
        slidePrev() {
            this.$refs.carousel.slidePrev();
        },
        slideNext() {
            this.$refs.carousel.slideNext();
        },
        sliderCustomCursor: function(e){
            let cursor = document.querySelector(".cursor");
            if(e.target.id=="right"){
            document.querySelector('.corporate-sustainability .cursor svg').classList.remove("rotateMe");
                cursor.classList.remove("hide");
            }
            else if(e.target.id=="left"){
            document.querySelector('.corporate-sustainability .cursor svg').classList.add("rotateMe");
                cursor.classList.remove("hide");
            }
            else{
                cursor.classList.add("hide");
            }
                gsap.to(cursor,{x:e.pageX, y: e.pageY, duration: 0.2});
        },
        hideCursor: function(){
            let cursor = document.querySelector(".cursor");
            cursor.classList.add("hide");
        }
    },
    mounted(){
        setTimeout(() => {
            this.controlerHeight()
        }, 1000);
        document.querySelectorAll(".slider-nav").forEach(link=>{
            link.addEventListener("mousemove", this.sliderCustomCursor);
            link.addEventListener("mouseout", this.hideCursor);
        });
    }
}
</script>


<style lang="scss" scoped>
    .section_three{
        position: relative;
        &:after  {
            content: '';
            position: absolute;
            
            @include Background('../../assets/images/corporate-sustainability/bg2.png');
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: -2;
        }
    }
    .corporate-sustainability {
       .hooper-navigation {
            @media screen and (min-width: 992px) {
                display: none!important;
            }
            
            .hooper-next {

            }
            /deep/ {
                .hooper-prev {
                    left: auto;
                    right: 50px;
                }
                .hooper-next, .hooper-prev {
                    top: -50px;
                    transform: unset;
                    color: #ffffff;
                    svg {
                        fill: currentColor;
                        transform: scale(1.5);
                    }
                }
            }
        }
        
        @media screen and (max-width: 991px) {
            .cursurControl {
                display: none!important;
            }
        }
        
    }
    
    // arabic
    [lang="ar"] {
        .section_three{
            &:after  {
                 -webkit-transform: scaleX(-1);
                transform: scaleX(-1);
                right: 0;
                left: auto;
            }
        }
        .corporate-sustainability {
            .hooper-navigation {
                
                
                
                /deep/ {
                    .hooper-prev {
                        right: auto;
                        left: 50px;
                    }
                    
                }
            }
        }
    }
    
</style>